import React, { useState } from 'react';
import { Plus, Minus } from '@phosphor-icons/react';

export const FAQ_ITEMS = [
  {
    q: 'Wie genau ist der Pendelkostenrechner?',
    a: 'Wir verwenden realistische Annahmen für Sprit (live oder Durchschnitt), 0,12 €/km für Verschleiß inkl. Wertverlust und Versicherungsanteil, sowie 46 Arbeitswochen pro Jahr. Die Berechnung ist eine sehr gute Schätzung — exakte Werte hängen von Fahrzeug, Versicherung und Fahrstil ab.',
  },
  {
    q: 'Werden meine Daten gespeichert?',
    a: 'Nein. Die gesamte Berechnung findet direkt in deinem Browser statt. Es wird nichts an einen Server gesendet. Nur wenn du den PDF-Export nutzt und deine E-Mail freiwillig angibst, speichern wir diese — sonst gar nichts.',
  },
  {
    q: 'Was ist die Pendlerpauschale 2025?',
    a: 'Die Entfernungspauschale beträgt 0,30 € pro Kilometer für die ersten 20 km und 0,38 € pro Kilometer ab dem 21. Kilometer. Sie reduziert dein zu versteuerndes Einkommen, nicht direkt die Steuer.',
  },
  {
    q: 'Wie funktioniert die Spritpreis-Automatik?',
    a: 'Über die offizielle Tankerkönig-Schnittstelle ziehen wir aktuelle Marktpreise rund um deine PLZ. Ohne API-Schlüssel zeigen wir bundesweite Durchschnittspreise. Du kannst den Preis jederzeit manuell anpassen.',
  },
  {
    q: 'Lohnt sich Homeoffice finanziell wirklich?',
    a: 'Bei einer Pendelstrecke von 25 km und 4 Bürotagen sparst du mit 1 Tag Homeoffice pro Woche schnell 600–900 € pro Jahr — plus rund 60 Stunden Lebenszeit. Bei größeren Distanzen entsprechend mehr.',
  },
  {
    q: 'Ist der Rechner kostenlos?',
    a: 'Ja, vollständig kostenlos. Keine Registrierung, keine Werbung, keine versteckten Kosten. Auch der PDF-Export ist kostenlos.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(-1);

  return (
    <section className="mt-24" data-testid="faq-section">
      <div className="grid-border">
        <div className="p-6 md:p-10 border-b border-neutral-200">
          <div className="text-xs uppercase tracking-widest text-neutral-500">FAQ</div>
          <h2 className="font-display text-3xl md:text-5xl mt-2 tracking-tighter">Häufige Fragen</h2>
        </div>
        <div>
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-neutral-200 last:border-b-0">
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left flex items-center justify-between p-6 md:p-8 hover:bg-neutral-50 transition-colors"
                >
                  <span className="font-display text-lg md:text-xl pr-6">{item.q}</span>
                  {isOpen ? <Minus size={22} weight="bold" /> : <Plus size={22} weight="bold" />}
                </button>
                {isOpen && (
                  <div className="px-6 md:px-8 pb-6 md:pb-8 max-w-3xl text-neutral-700 leading-relaxed" data-testid={`faq-answer-${i}`}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function FaqJsonLd() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_ITEMS.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
